import React from 'react';

import Background from './hoc/Layout/Background/Background';
import Header from './hoc/Layout/Header/Header';
import Main from './hoc/Layout/Main/Main';

import Section from './containers/Section/Section';
import Panels from './containers/Panels/Panels';
import Report from './containers/Report/Report';

import AddMetaTag1 from './components/AddMetaTag1/AddMetaTag1';
import Nav2 from './components/Navigation/Nav2/Nav2';
import Footer from './components/Footer/Footer';
import Gate from './components/Gate/Gate'; // gate prior
import Gate1 from './components/Gate/Gate1'; // eloqua form request
import Saleschat from './components/Saleschat/Saleschat';
import SrcBox from './components/SrcBox/SrcBox'; // viktor
// import Socials from './components/Socials/Socials';

import QuestionSets from './libs/QuestionSets';

import './App.scss';
import SpiderClass from './components/Spider/SpiderClass';

const App = (props) => {
  const search = window.location.search; // could be '?foo=bar'
  const params = new URLSearchParams(search);
  const finish = params.get('finish');
  const report = params.get('report');
  const role = params.get('role') && params.get('role').split('_').join(" ");
  let score = params.get('score');

  let srcBox = finish ? null : (<SrcBox/>);
  score = score ? score.split('_').map(scr => Number(scr)) : null;


  const retThis = 
    report ? (      
      <Report
        scrs={score}
        rol={role}
        prms={params}
      />      
  ) : (
    <React.Fragment>
      <AddMetaTag1/>
      {/* <Saleschat/> */}
      {/* {/* <Gate/> */}
      <Gate1/>
      {/* {srcBox} */}
      <Header />
      <Main>
        <Section
          side={'left'}
        >
          <Panels
            panels={QuestionSets}
          />
        </Section>
        <Section
          side={'right'}
        >
          <SpiderClass
          // levels={3}
          />        
        </Section>
      </Main>
      <Background />
      <Nav2
        questions={[...QuestionSets['Choose your role']]}
      />
      {/* <Socials/> */}
      <Footer />
      <Saleschat/>
    </React.Fragment>
  );

  return retThis;
}

export default App;


